<template>
  <div class="main__sort" >
    <i class="i i-filter" @click="toggle"></i>
    <div class="sort" :class="{'sort--active': isActive}" >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
.main__sort {
  .i {
    color: $color-link;
    cursor: pointer;
    @include mq('md') {
      display: none;
    }
  }
}
.sort {
  display: none;
  &--active {
    background: $color-background-overlay;
    position: absolute;
    display: flex;
    flex-direction: column;
    right: 0;
    top: calc(100% + 10px);
    z-index: 100;
    white-space: nowrap;
    padding: 10px;
    .btn {
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
  @include mq('md') {
    display: block!important;
  }
}
</style>

<script>
export default {
  props: {
    iframe: String,
  },
  data: () => ({
    isActive: false
  }),
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    }
  },
  computed: {
    iframeUTM() {
      return this.iframe + this.$root.$cjer.utmString(false)
    }
  },
  created() {
    document.addEventListener('click', (e) => {
       if(!e.target.closest('.main__sort')) {
        this.isActive = false
      }
    });
  }
}
</script>
